import BaseController from '../common/location_zone.base.controller';

class LocationZoneCreateController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, LocationZoneService, Modal, $translate, $q, CommonLayoutService, UserBranchService) {

        super(Auth, $state, User, LocationZoneService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.$q = $q;
        this.LocationZoneService = LocationZoneService;
        this.CommonLayoutService = CommonLayoutService;
        this.UserBranchService = UserBranchService;
        this.branch = [];

        this.defaultModel = {
            loading: false,
            name: '',
            type: null,
            description: '',
            branchId: this.User.getUser().branchId,
            loggedInUserId: this.User.getUser().id
        };
        this.model = angular.copy(this.defaultModel);
        this.locationZoneTypes = this.CommonLayoutService.locationZoneTypes();
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.UserBranchService.getUserBranches(this.defaultModel.loggedInUserId)
        ])
        .then((data) => {
            data[0].results.map((b) => this.branch.push(b.branchId));
        })
        .catch((err) => {
            if (err && err.data && err.data.errors) {
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
            }
            else if (err && err.data && err.data.message) {
                this.errorMessage = err.data.message;

            }
            else {
                this.errorMessage = err;
            }
        })
        .finally(() => {
            this.model.loading = false;
        })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }

    submit(evt) {
        this.loading = true;
        this.Service.create({
            name: this.model.name,
            type: this.model.type,
            description: this.model.description,
            createdByUserId: this.model.loggedInUserId,
            modifiedByUserId: this.model.loggedInUserId,
            branchId: this.model.branchId
        })
            .then((data) => {
                this.loading = false;
                this.askCreate();
            })
            .catch((err) => {
                this.loading = false;
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
            })
    }
}

export default LocationZoneCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/create/location_zone.create.controller.js